import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

// @roadiehq/backstage-plugin-jira ainda não porta para o new frontend system
// (sem export "/alpha") — só exporta o componente legado + a checagem de
// disponibilidade (isJiraAvailable), que aqui equivale ao filter abaixo.
// EntityCardBlueprint + compatWrapper é o caminho oficial pra plugins
// de terceiros fora do nosso controle (ver docs/frontend-system/building-apps/plugin-conversion).
const jiraOverviewCard = EntityCardBlueprint.make({
  name: 'jira-overview',
  params: {
    filter: entity =>
      Boolean(entity.metadata.annotations?.['jira/project-key']),
    loader: () =>
      import('@roadiehq/backstage-plugin-jira').then(m =>
        compatWrapper(<m.EntityJiraOverviewCard />),
      ),
  },
});

export const jiraModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [jiraOverviewCard],
});
